<template>
<div class="h-dialogContainer">
  <div class="row">
    <div class="col-sm-4">
       <div class="h-subscriber-input-qry-width">
                 <ejs-textbox :placeholder='SearchHolder' v-model='keywords'  @change='searchNeName'>
                    <span class="icon hero-icon hero-icon-search"></span>
                </ejs-textbox>
       </div>
       <div class="h-borderBox height-406">
        <div class="h-borderTree-pm-content">
          <AdditionalNeTree ref="additionalNeTree" ></AdditionalNeTree>
        </div>
      </div>
    </div>
    <div class="col-sm-8">
      <div class="h-borderBox height-440">
        <div class="h-borderTree-pm-content">
          <AdditionalMeasureTree ref="additionalMeasureTree" ></AdditionalMeasureTree>
        </div>
      </div>
    </div>
  </div>
   
 <div class="row h-row-inputBox" style="margin-top: 20px;">
   
     <form id="AdditionalMeasureKpiTime">
        <div class="col-sm-5 h-col-inputBox">
          <div class="h-inputLit">{{$t('Pm.startTime')}}:</div>
          <ejs-datetimepicker
            :format='dateFormat'
            enabled='true'
            name="startTime"
            :locale='locale'
            v-model='startTime'
             :min='minTime'
             :max='maxTime'
          ></ejs-datetimepicker>
        </div>
     
   
        <div class="col-sm-5 h-col-inputBox" >
          <div class="h-inputLit">{{$t('Pm.endTime')}}:</div>
          <ejs-datetimepicker
            :format='dateFormat'
            enabled='true'
            name="endTime"
            :locale='locale'
            v-model='endTime'
            :min='minTime'
            :max='maxTime'
          ></ejs-datetimepicker>
        </div>

     </form>
 </div>




</div>
</template>

<script>
import AdditionalNeTree from '../AdditionalNeTree';
import AdditionalMeasureTree from '../AdditionalMeasureTree';
export default {
  name: 'AdditionalDealKpiDataView',
  props: [
  ],
  data() {
    return { 
        timeEnabled:false,
        locale: localStorage.getItem('locale'),
        dateFormat: 'yyyy-MM-dd HH:mm:ss',
        // startTime: beforeTwoDay(),
        startTime: new Date(),
        endTime: new Date(),
        maxTime: new Date(),
        minTime: new Date(),
        SearchHolder:this.$t('MML.searchHolder'),
        keywords : '',
      };
  },
  components: {
    AdditionalNeTree,
    AdditionalMeasureTree,
  },
  methods: {
     searchNeName() {
          this.$refs.additionalNeTree.getNeTreeForDataSearch(this.keywords);
     },
     // 前两天
     beforeTwoDay() {
      let beforeTwoDay = new Date(
        this.endTime.getTime() -
          24 * 60 * 60 * 1000 -
          24 * 60 * 60 * 1000
      ); //计算当前日期 -2
      this.startTime = this.formatDateTime(beforeTwoDay); //格式化日期并赋值
      this.minTime = this.formatDateTime(beforeTwoDay); //格式化日期并赋值
    },
    formatDateTime(timeStamp) {
        var date = new Date();
        date.setTime(timeStamp);
        var y = date.getFullYear();
        var m = date.getMonth() + 1;
        m = m < 10 ? ('0' + m) : m;
        var d = date.getDate();
        d = d < 10 ? ('0' + d) : d;
        var h = date.getHours();
        h = h < 10 ? ('0' + h) : h;
        var minute = date.getMinutes();
        var second = date.getSeconds();
        minute = minute < 10 ? ('0' + minute) : minute;
        second = second < 10 ? ('0' + second) : second;
        return y + '-' + m + '-' + d+' '+h+':'+minute+':'+second;
    },
  }
};
</script>
